export const ROUTES_WITH_TOOLTIP = ['outfitsCreate'];
